import React, { useEffect, useState, useRef } from "react";
import {
  Checkbox,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import dayjs from "dayjs";
import SearchableMultiSelectDropdown from "../../../../common/SearchableMultiSelectDropdown";
import DateRangePicker from "../../../../common/CustomDateRangePicker";
import {
  FetchStakeholderContactByUserId,
  ValidateAppointmentByDateandMonth,
} from "../../../../services/DoctorScheduleAPI";
import DatePicker from "react-datepicker";
import {
  getAssociatedHospitalList,
  getdHospitalList,
  addDoctorSchedule,
  updateDoctorSchedule,
  fetchMonthData,
} from "../../../../services/QMEProfileScedule";
import { fetcQMEDoctorHospitalList } from "../../../../services/ScheduleAppointmentApi";
import { Badge, Modal } from "react-bootstrap";
import Snackbar from "../../../../common/Snackbar";
import Loader from "../../../../common/Loader";
import HospitalCardDetails from "./HospitalCradDetails";
import ViewSchedule from "../index";

import {
  Tabs,
  Tab,
  Form,
  Row,
  Button,
  Container,
  FloatingLabel,
  Col,
} from "react-bootstrap";
import TimePicker from "../../../../common/TimePicker";
import TextInput from "../../../../common/TextInput";
import moment, { weekdays } from "moment";
import { RootState } from "../../../../redux/Store";
import { useSelector } from "react-redux";
import { ToggleButton } from "react-bootstrap";
import { id } from "date-fns/locale";
import {
  FetchDoctorScheduleDetails,
  FetchMedicareList,
} from "../../../../services/DoctorScheduleAPI"; //updateDoctorSchedule
import AccordionComponent from "../../../../common/Accordion";
import EndTimePicker from "../../../../common/EndTimePicker";
import { searchManualZipCode } from "../../../../services/StakeholderApi";
import SearchableAddressDropdown from "../../../../common/SearchableZipDropdown";
import { getPlaceByAddress } from "../../../../utils/getPlaceByAddress";
import { isValidCoordinate } from "../../../../utils/validators";
import { addMedicareLocation } from "../../../../services/SystemLocationAPI";
import { MANAGE_SCHEDULE_ACTIONS } from "../../../../common/EventConstant";
import { PICKLIST_GROUP_NAME } from "../../../../common/Constant";
import { fetchPickListByGroupName } from "../../../../services/CaseInformationApi";
import MultilineTextBox from "../../../../common/MultilineTextBox";
import DataTable from "../../../../common/DataTable";
import { APPOINTMENT_LIST_ON_VIEW_SCHEDULE } from "../actions/constant";
import { RequestForRescheduleAppointment } from "../../../../services/AppointmentsAPI";
import { formatDateTime } from "../../../../utils/dateUtils";
import SearchAutosuggest from "../../../../common/SearchAutosuggestLocations";
import { normalizeCountry, normalizeState } from "../../../../utils/normalizer";
import SearchHospitalAutosuggest, { LocationSuggestion } from "../../../../common/SearchHospitalAutosuggest";

interface HospitalClinicSearchResult {
  areaName: string;
  districtName: string;
  localeName: string;
  physicalCity: string;
  physicalState: string;
  physicalZip: string;
  country: string;
}

interface Option {
  providerName?: string;
  localeName?: string;
  physicalCity?: string;
  physicalZip?: string;
  physicalState?: string;
  districtName?: string;
  countryName?: string;
  providerAddress?: string;
  country?: string;
  medicareId?: Number;
}
interface DoctorSchedulePayload {
  scheduleId: number;
  qmeDoctorContactId: number;
  scheduleType: string;
  scheduleMode: string;
  selectedMonths: string;
  startDate: string | null;
  endDate: string | null;
  selectedWeekDays: string;
  startTime: String;
  endTime: String;
  medicareProviderId: number | null;
  newMedicareProviderId: number | null;
  newEmailAddress: string;
  newPhoneNumber: string;
  newFaxNumber: string;
  nonAvailabilityReason: string;
  newMedicareName?: string;
  newAddressLine1?: string;
  newCity?: string;
  newState?: string;
  newZip?: string;
  splInstructionsPayload?: any;
}

interface AddScheduleProps {
  selectedRowData: any;
  subTab: string;
  QMEDoctor: any;

  onTabChange: () => void;
}

const AvailabilityForm: React.FC<AddScheduleProps> = ({
  selectedRowData,
  onTabChange,
  subTab,
  QMEDoctor,
}) => {
  const [validDays, setValidDays] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");
  const [scheduleStatus, setScheduleStatus] = useState("Availability");
  const [availabilityBy, setAvailabilityBy] = useState("Month");
  const [monthOptions, setmonthOptions] = useState<any[]>([]);
  const [associatedHospitalOptions, setassociatedHospitalOptions] = useState<
    any[]
  >([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [availableDays, setAvailableDays] = useState<string[]>([]);
  const [startTime, setStartTime] = useState<any>("");
  const [endTime, setEndTime] = useState<any>("");
  const [duration, setDuration] = useState<string | null | number>(null);
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);
  const [stakeholderContactId, setStakeholderContactId] =
    useState(loggedInUserid);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedMonth, setselectedMonth] = useState<(string | string)[]>([]);
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    null,
    null,
  ]);
  const [showViewSchedule, setShowViewSchedule] = useState(false);
  const [isOtherHospitalVisible, setIsOtherHospitalVisible] =
    useState<boolean>(false);
  const [selectedHospital, setSelectedHospital] = useState<any>(null);
  const [zipCode, setZipCode] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [providerName, setProviderName] = useState("");
  const [providerAddress, setProviderAddress] = useState("");
  const [country, setCountry] = useState("");
  const [emailAddress, setemailAddress] = useState("");
  const [phoneNumber, setphoneNumber] = useState("");
  const [faxNumber, setfaxNumber] = useState("");
  const [unavailableWeekdays, setUnavailableWeekdays] = useState<string[]>([]);

  const [nonAvailabilityReason, setnonAvailabilityReason] =
    useState<String>("");
  const [setcontactMedicareListId, setsetcontactMedicareListId] =
    useState<Number>();
  const [result, setResult] = useState<any>({});
  const [MedicareProviderName, setMedicareProviderName] = useState<any>();
  const [dateFrom, setDateFrom] = useState<string | null>(null);
  const [dateTo, setDateTo] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [suggestionSelected, setSuggestionSelected] = useState(false);
  const [suggestionFilled, setSuggestionFilled] = useState({ city: false, state: false, country: false, zipCode: false });
  const dayToIndexMap: { [key: string]: number } = {
    Sun: 0,
    Mon: 1,
    Tue: 2,
    Wed: 3,
    Thu: 4,
    Fri: 5,
    Sat: 6,
  };

  const [hospitalList, setHospitalList] = useState<
    { label: string; value: string }[]
  >([]);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [isNewAdded, setIsNewAdded] = useState(true);

  const [isManualEntry, setIsManualEntry] = useState(false);
  const [manualLocation, setManualLocation] = useState("");
  const [manualAddress, setManualAddress] = useState("");
  const [manualCity, setManualCity] = useState("");
  const [manualState, setManualState] = useState("");
  const [manualCountry, setManualCountry] = useState("");
  const [manualZip, setManualZip] = useState("");

  const [cityOptions, setCityOptions] = useState<string[]>([]);
  const [stateOptions, setStateOptions] = useState<string[]>([]);
  const [countryOptions, setCountryOptions] = useState<string[]>([]);
  const [zipOptions, setZipOptions] = useState<string[]>([]);

  const dropdownRef = useRef<HTMLDivElement>(null);

  const [instructionOption, setInstructionOption] = useState<
    { value: string; label: string }[]
  >([]);

  const allowedFeatures = useSelector(
    (state: RootState) => state.featureAccess.allowedFeatures,
  );
  const isAddManualLocation = allowedFeatures.has(
    MANAGE_SCHEDULE_ACTIONS.ADD_MANUAL_LOCATION,
  );
  const [isManualLocation, setIsManualLocation] = useState(false);
  const [pendingGoogleLocation, setPendingGoogleLocation] = useState<any>(null);
  const params = {
    location: {
      groupName: PICKLIST_GROUP_NAME.Location_SplInstructions,
      triggerById: loggedInUserid,
    },
  };

  const fetchCategoryData = async () => {
    try {
      const categoryData = await fetchPickListByGroupName(params.location);

      setInstructionOption(categoryData || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (loggedInUserid) fetchCategoryData();
  }, [loggedInUserid]);

  const handleCancel = () => {
    setOpenConfirm(true);
  };
  useEffect(() => {
    if (QMEDoctor) {
      setStakeholderContactId(QMEDoctor);
    }
  }, [QMEDoctor]);
  useEffect(() => {
    if (subTab === "Add Schedule" && isNewAdded == true) {
      resetForm();
    }
  }, [subTab]);

  const resetForm = () => {
    setScheduleStatus("Availability");
    setAvailabilityBy("Month");
    setselectedMonth([]);
    setAvailableDays([]);
    setDateRange([null, null]);
    setStartTime("");
    setEndTime("");
    setSelectedHospital(null);
    setnonAvailabilityReason("");
    setCity("");
    setCountry("");
    setState("");
    setZipCode("");
    setAddress("");
    setSearchQuery("");
    setSuggestionSelected(false);
    setSuggestionFilled({ city: false, state: false, country: false, zipCode: false });
    setIsOtherHospitalVisible(false);
    setPendingGoogleLocation(null);
    resetManualLocationFields();
  };
  const getUnavailableDays = (
    range: [Date | null, Date | null],
    valid: string[],
  ) => {
    if (!range[0] || !range[1]) return [];

    const allWeekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const availableWeekdays = new Set<string>();

    let current = new Date(range[0]);
    const end = new Date(range[1]);

    while (current <= end) {
      const weekday = allWeekdays[current.getDay()];
      availableWeekdays.add(weekday);
      current.setDate(current.getDate() + 1);
    }

    // Return weekdays that are not in the date range
    return allWeekdays.filter(
      (day) =>
        !availableWeekdays.has(day) ||
        (valid.length > 0 && !valid.includes(day)),
    );
  };

  useEffect(() => {
    const bindFormData = () => {
      if (!selectedRowData) return;
      // Schedule Type & Mode
      setScheduleStatus(selectedRowData.scheduleType || "");
      setAvailabilityBy(
        selectedRowData.scheduleMode === "Month" ? "Month" : "Date Range",
      );

      // Selected Months (if not null)
      setselectedMonth(
        selectedRowData.selectedMonths
          ? selectedRowData.selectedMonths.split(",")
          : [],
      );

      // Selected Weekdays
      setAvailableDays(
        selectedRowData.selectedWeekdays
          ? selectedRowData.selectedWeekdays.split(",")
          : [],
      );
      // Date Range
      const startDate = selectedRowData.startDate
        ? new Date(selectedRowData.startDate)
        : null;
      const endDate = selectedRowData.endDate
        ? new Date(selectedRowData.endDate)
        : null;
      setDateRange([startDate, endDate]);

      // Time extraction (local time, not UTC)
      const extractLocalTime = (iso: string | null) => {
        if (!iso) return "";
        const date = new Date(iso);
        return `${String(date.getHours()).padStart(2, "0")}:${String(
          date.getMinutes(),
        ).padStart(2, "0")}`;
      };

      setStartTime(extractLocalTime(selectedRowData.startTime));
      setEndTime(extractLocalTime(selectedRowData.endTime));

      // Match Medicare Hospital
      const matchedHospital = associatedHospitalOptions.find(
        (h) =>
          String(h.medicareId) === String(selectedRowData.medicareProviderId),
      );
      if (matchedHospital) {
        setSelectedHospital(matchedHospital);
        setsetcontactMedicareListId(matchedHospital.medicareId);
      } else {
        setSelectedHospital(null);
        setsetcontactMedicareListId(undefined);
      }

      // Non-availability Reason
      setnonAvailabilityReason(selectedRowData.nonAvailabilityReason || "");
      setResult(selectedRowData);
    };

    // Only bind if proper conditions are met
    if (selectedRowData && subTab === "Add Schedule") {
      bindFormData();
    }
  }, [selectedRowData, associatedHospitalOptions, subTab, isNewAdded]);
  useEffect(() => {
    if (dateRange[0] && dateRange[1]) {
      const unavailable = getUnavailableDays(dateRange, validDays);
      setUnavailableWeekdays(unavailable);
    }
  }, [dateRange, validDays]);

  ///////////////////////////////////////////
  const fetchData = async () => {
    if (selectedRowData) {
      try {
        const response = await FetchDoctorScheduleDetails(
          selectedRowData.scheduleId,
        );
        if (response.isSuccess) {
          setScheduleStatus(selectedRowData.scheduleType);
          setAvailabilityBy(
            selectedRowData.scheduleMode === "Month" ? "Month" : "Date Range",
          );
          setselectedMonth(
            selectedRowData.selectedMonths
              ? selectedRowData.selectedMonths[0].split(",")
              : [],
          );

          setAvailableDays(
            Array.isArray(response?.result?.selectedWeekDays)
              ? response.result.selectedWeekDays
              : [],
          );
          setDateRange([
            selectedRowData.startDate === "N/A"
              ? null
              : selectedRowData.startDate,
            selectedRowData.endDate === "N/A" ? null : selectedRowData.endDate,
          ]);

          setStartTime(selectedRowData.startTime);
          setEndTime(selectedRowData.endTime);

          const matchedHospital = associatedHospitalOptions.find(
            (hospital) =>
              hospital.medicareId === selectedRowData.medicareProviderId,
          );
          setResult(selectedRowData || {});
        } else {
          alert("Failed to fetch schedule details.");
        }
      } catch (error) {
        console.error("Error fetching schedule details:", error);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, [selectedRowData]);

  useEffect(() => {
    if (
      selectedRowData?.medicareProviderId &&
      associatedHospitalOptions?.length
    ) {
      // Ensure type consistency when comparing values
      const selectedClinic = associatedHospitalOptions?.find(
        (clinic) =>
          String(clinic.medicareId) ===
          String(selectedRowData.medicareProviderId),
      );

      if (selectedClinic) {
        setSelectedHospital({
          providerName: selectedClinic.providerName || "",
          providerAddress: selectedClinic.providerAddress || "",
          emailAddress: selectedClinic.emailAddress || "",
          PhoneNumber: selectedClinic.phoneNumber || "",
          faxNumber: selectedClinic.faxNumber || "",
        });
      }
    }
  }, [associatedHospitalOptions, result]);

  useEffect(() => {
    fetchAssociatedHospitalList();
  }, [stakeholderContactId]);
  const userRole = localStorage.getItem("userrole") || "";
  const roles = userRole ? userRole.split(",").map((r) => r.trim()) : [];

  useEffect(() => {
    if (stakeholderContactId && QMEDoctor) {
      fetchAssociatedHospitalList();
    }
  }, [stakeholderContactId, QMEDoctor]);

  const fetchAssociatedHospitalList = async () => {
    try {
      let list;

      if (roles.includes("Case Coordinator")) {
        list = await fetcQMEDoctorHospitalList(QMEDoctor);
      } else {
        list = await getAssociatedHospitalList(loggedInUserid);
      }

      setassociatedHospitalOptions(list);
      setSelectedHospital(null);
    } catch (error) {
      console.error("Error fetching picklist data:", error);
    }
  };

  const handleToggleOtherHospital = () => {
    setSearchQuery("");
    setSelectedHospital(null);
    setCity("");
    setState("");
    setCountry("");
    setZipCode("");
    setAddress("");
    setSuggestionSelected(false);
    setSuggestionFilled({ city: false, state: false, country: false, zipCode: false });
    setPendingGoogleLocation(null);
    setsetcontactMedicareListId(undefined);
    setIsOtherHospitalVisible(!isOtherHospitalVisible);
    resetManualLocationFields();
  };
  const handleSuggestionSelect = (suggestion: LocationSuggestion) => {
    const newStateCode = suggestion.physicalStateCode || normalizeState(suggestion.physicalState || "");
    const newCountryCode = normalizeCountry(suggestion.country || "USA");
    if (suggestion.source === "google") {
      setPendingGoogleLocation({
        source: "google",
        providerName: suggestion.providerName,
        providerAddress: suggestion.providerAddress,
        physicalCity: suggestion.physicalCity,
        physicalState: newStateCode,
        physicalZip: suggestion.physicalZip,
        countryName: newCountryCode,
        county: suggestion.county,
        areaName: suggestion.areaName || "",
        latitude: isValidCoordinate(suggestion.latitude) ? String(suggestion.latitude) : "",
        longitude: isValidCoordinate(suggestion.longitude) ? String(suggestion.longitude) : "",
      });
    } else {
      setPendingGoogleLocation(null);
    }
    setSuggestionSelected(true);
    setSuggestionFilled({
      city: !!suggestion.physicalCity,
      state: !!newStateCode,
      country: !!newCountryCode,
      zipCode: !!suggestion.physicalZip,
    });
    setCity(suggestion.physicalCity || "");
    setState(newStateCode);
    setCountry(newCountryCode);
    setZipCode(suggestion.physicalZip || "");
    setAddress(suggestion.providerAddress || "");
    if (suggestion.medicareId) setsetcontactMedicareListId(Number(suggestion.medicareId));
  };

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (!event.target.closest(".form-floating")) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const handleSelectDropdown = (option: any) => {
    setSelectedHospital(option);
    setDropdownOpen(false);
    setProviderName(option.providerName || "");
    setProviderAddress(option.providerAddress || "");
    setphoneNumber(option.phoneNumber || "");
    setemailAddress(option.emailAddress || "");
    setfaxNumber(option.faxNumber || "");
    setCountry(option.countryName);
    setsetcontactMedicareListId(option.medicareId);
  };

  useEffect(() => {
    if (startTime && endTime) {
      const start = new Date(`1970-01-01T${startTime}:00`);
      const end = new Date(`1970-01-01T${endTime}:00`);
      const diffInMilliseconds = end.getTime() - start.getTime();
      const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));

      if (diffInMinutes >= 0) {
        const hours = Math.floor(diffInMinutes / 60);
        const minutes = diffInMinutes % 60;
        let durationString = "";
        if (hours > 0) durationString += `${hours}h`;
        if (minutes > 0) durationString += ` ${minutes}m`;
        setDuration(durationString.trim());
      } else {
        setDuration("");
      }
    } else {
      setDuration("");
    }
  }, [startTime, endTime]);

  interface Month {
    monthDisplay: string;
  }

  useEffect(() => {
    const getMonths = async () => {
      try {
        const months = await fetchMonthData();
        if (months.isSuccess && Array.isArray(months.result)) {
          const formattedMonths = months.result.map((monthObj: Month) => ({
            label: monthObj.monthDisplay,
            value: monthObj.monthDisplay,
          }));
          setmonthOptions(formattedMonths);
        } else {
          console.error("Failed to fetch month data:", months.message);
        }
      } catch (error) {
        console.error("Error fetching months:", error);
      }
    };

    getMonths();
  }, []);
  useEffect(() => {
    setAvailableDays((prev) => prev.filter((day) => validDays.includes(day)));
  }, [validDays]);

  // useEffect(() => {
  //   const fetchContactId = async () => {
  //     try {
  //       const response = await FetchStakeholderContactByUserId(loggedInUserid);

  //       if (response?.isSuccess && response.result?.stakeholderContactId) {
  //         setStakeholderContactId(response.result.stakeholderContactId);
  //       } else {
  //         console.warn("⚠️ No Stakeholder Contact ID found.");
  //       }
  //     } catch (error) {
  //       console.error("❌ Error fetching stakeholder contact ID:", error);
  //     }
  //   };

  //   fetchContactId();
  // }, [loggedInUserid]);

  const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  const handleDayChange = (day: string) => {
    if (availableDays.includes(day)) {
      setAvailableDays(availableDays.filter((d) => d !== day));
    } else {
      setAvailableDays([...availableDays, day]);
    }
  };
  const handleStartTimeChange = (time: string) => {
    setStartTime(time);
    // Validate if the time is in HH:MM format
    const isValidTime = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(time);
    if (isValidTime) {
      // Calculate end time (30 minutes after start time)
      const [hours, minutes] = time.split(":").map(Number);
      // Calculate total minutes from 00:00
      const totalMinutes = hours * 60 + minutes;
      const endTotalMinutes = totalMinutes + 30;

      // If end time exceeds 23:59 (1439 minutes), cap it
      const finalMinutes = Math.min(endTotalMinutes, 1439);
      const endHours = Math.floor(finalMinutes / 60);
      const endMinutes = finalMinutes % 60;

      const newEndTime = `${String(endHours).padStart(2, "0")}:${String(
        endMinutes,
      ).padStart(2, "0")}`;
      setEndTime(newEndTime);
    } else {
      setEndTime("");
    }
  };
  const handleAvailabilityChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setAvailabilityBy(value);

    if (value === "Month") {
      // Reset Date Range
      setDateRange([null, null]);
      setDateFrom(null);
      setDateTo(null);
      setValidDays([]);
      setAvailableDays([]);
    } else if (value === "Date Range") {
      // Reset Month selection (example if you're using a `selectedMonth` state)
      setselectedMonth([]);
      setAvailableDays([]);
      setValidDays([]);
    }
  };

  const handleSave = async () => {
    let validationMessages: string[] = [];
    if (!scheduleStatus)
      validationMessages.push("Please select Schedule Status.");
    if (availabilityBy === "Date Range" && (!dateRange[0] || !dateRange[1])) {
      validationMessages.push("Please select Start and End Date.");
    }
    if (availabilityBy === "Month" && selectedMonth.length === 0) {
      validationMessages.push("Please select at least one month.");
    }
    if (availableDays.length === 0) {
      validationMessages.push("Please select at least one weekday.");
    }
    if (scheduleStatus === "Availability") {
      if (!startTime) {
        validationMessages.push("Start Time is mandatory.");
      }

      if (!endTime) {
        validationMessages.push("End Time is mandatory.");
      }

      const isValidHHmm = (time: string) =>
        /^([01]\d|2[0-3]):([0-5]\d)$/.test(time);
      const parseTime = (time: string) => {
        const [hours, minutes] = time.split(":").map(Number);
        return hours * 60 + minutes;
      };

      if (startTime && endTime) {
        if (!isValidHHmm(startTime) || !isValidHHmm(endTime)) {
          validationMessages.push("Time must be in HH:mm format");
        } else {
          const start = parseTime(startTime);
          const end = parseTime(endTime);

          if (end <= start) {
            validationMessages.push("End Time must be greater than Start Time");
          }
        }
      }
    }

    if (scheduleStatus === "Availability") {
      if (
        !isManualEntry &&
        !selectedHospital &&
        (!isOtherHospitalVisible ||
          !address ||
          !city ||
          !state ||
          !country ||
          !zipCode)
      ) {
        validationMessages.push("Please select a Location.");
      }
      if (isManualEntry) {
        if (!manualLocation) {
          validationMessages.push("Please add Manual Location.");
        }
        if (!manualAddress) {
          validationMessages.push("Please add Manual Address.");
        }
        if (!manualCity) {
          validationMessages.push("Please add Manual City.");
        }
        if (!manualState) {
          validationMessages.push("Please add Manual State.");
        }
        if (!manualCountry) {
          validationMessages.push("Please add Manual Country.");
        }
        if (!manualZip) {
          validationMessages.push("Please add Manual Zip.");
        }
      }
    }

    if (validationMessages.length > 0) {
      setSnackbarMessage(validationMessages.join("\n"));
      setError("error");
      setSnackbarOpen(true);
      return;
    }

    const getCurrentTime = () => {
      const now = new Date();
      return `${String(now.getHours()).padStart(2, "0")}:${String(
        now.getMinutes(),
      ).padStart(2, "0")}`;
    };

    const handleStartTimeChange = (time: string | null) => {
      const newStartTime = time || getCurrentTime();
      setStartTime(newStartTime);

      const [hours, minutes] = newStartTime.split(":").map(Number);
      const date = new Date();
      date.setHours(hours, minutes, 0, 0);
      date.setMinutes(date.getMinutes() + 30);

      const newEndTime = `${String(date.getHours()).padStart(2, "0")}:${String(
        date.getMinutes(),
      ).padStart(2, "0")}`;

      setEndTime(newEndTime);
    };

    const handleEndTimeChange = (time: string | null) => {
      setEndTime(time || getCurrentTime());
    };
   
    setLoading(true);

    await getAppointmentListWhileAddingUnAvailability();

    if (appointmentCount > 0 && scheduleStatus === "Non-Availability") {
      setShowCancelModal(true);
      setLoading(false);
      return;
    }

    const today = new Date();
    const todayStr = today.toISOString().split("T")[0];

    const parsedStartTime = `${todayStr}T${startTime || getCurrentTime()}:00`;
    const parsedEndTime = `${todayStr}T${endTime || getCurrentTime()}:00`;

    const parsedStartDate = dateRange[0]
      ? new Date(dateRange[0]).toLocaleDateString("en-CA") // "YYYY-MM-DD" format
      : null;

    const parsedEndDate = dateRange[1]
      ? new Date(dateRange[1]).toLocaleDateString("en-CA")
      : null;

    let fixedLoc: { latitude?: number | null; longitude?: number | null } = {};
    if (manualLocation) {
      const addressInDetails = `${manualAddress}, ${manualCity}, ${manualState}, ${manualZip}, ${manualCountry}`;
      const locationInDetails = `${manualLocation}, ${manualCity}, ${manualState}, ${manualZip}, ${manualCountry}`;
      const locationFullDetails = `${manualLocation}, ${manualAddress}, ${manualCity}, ${manualState}, ${manualZip}, ${manualCountry}`;

      const placeResult = await getPlaceByAddress({
        name: locationInDetails,
        address: addressInDetails,
        fullAddress: locationFullDetails,
      });
      if (placeResult) {
        fixedLoc = {
          latitude: placeResult.latitude,
          longitude: placeResult.longitude,
        };
      }
    }

    let splInstructionsPayload: any[] = [];
    splInstructionsPayload = instructionOption.map((opt: any) => ({
      SplInstructionID: opt.value,
      SplInstructionData: "",
    }));

    const useGoogleFallback =
      isOtherHospitalVisible &&
      scheduleStatus !== "Non-Availability" &&
      !isManualEntry &&
      pendingGoogleLocation?.source === "google";

    const basePayload: DoctorSchedulePayload = {
      scheduleId: selectedRowData?.scheduleId || 0,
      qmeDoctorContactId: Number(stakeholderContactId),
      scheduleType: scheduleStatus,
      scheduleMode: availabilityBy,
      selectedMonths: selectedMonth.join(","),
      startDate: parsedStartDate,
      endDate: parsedEndDate,
      selectedWeekDays: availableDays.join(","),
      startTime: parsedStartTime,
      endTime: parsedEndTime,
      medicareProviderId: isManualEntry
        ? null
        : scheduleStatus === "Non-Availability"
          ? null
          : !isOtherHospitalVisible &&
              setcontactMedicareListId &&
              Number(setcontactMedicareListId) !== 0
            ? Number(setcontactMedicareListId)
            : null,

      newMedicareProviderId: isManualEntry
        ? null
        : scheduleStatus === "Non-Availability"
          ? null
          : isOtherHospitalVisible &&
              setcontactMedicareListId &&
              Number(setcontactMedicareListId) !== 0
            ? Number(setcontactMedicareListId)
            : null,

      newEmailAddress: "",
      newPhoneNumber: "",
      newFaxNumber: "",
      nonAvailabilityReason: String(nonAvailabilityReason) || "",
      newMedicareName: useGoogleFallback
        ? pendingGoogleLocation.providerName || manualLocation || ""
        : manualLocation ? manualLocation : "",
      newAddressLine1: useGoogleFallback
        ? address || pendingGoogleLocation.providerAddress || ""
        : manualAddress ? manualAddress : "",
      newCity: useGoogleFallback
        ? city || pendingGoogleLocation.physicalCity || ""
        : manualCity ? manualCity : "",
      newState: useGoogleFallback
        ? state || pendingGoogleLocation.physicalState || ""
        : manualState ? manualState : "",
      newZip: useGoogleFallback
        ? zipCode || pendingGoogleLocation.physicalZip || ""
        : manualZip ? manualZip : "",
    };

    const payload = {
      ...basePayload,
      ...(useGoogleFallback && {
        latitude: String(pendingGoogleLocation.latitude),
        longitude: String(pendingGoogleLocation.longitude),
        splInstructions: splInstructionsPayload,
      }),
      ...(!useGoogleFallback &&
        manualLocation &&
        isValidCoordinate(fixedLoc?.latitude) &&
        isValidCoordinate(fixedLoc?.longitude) && {
          latitude: String(fixedLoc.latitude),
          longitude: String(fixedLoc.longitude),
        }),
      ...(!useGoogleFallback && manualLocation && {
        splInstructions: splInstructionsPayload,
      }),
    };

    try {
      if (selectedRowData?.scheduleId) {
        const response = await updateDoctorSchedule(payload);
        if (response.result.id > 0) {
          setSnackbarMessage("Schedule updated successfully!");
          resetManualLocationFields();
          setError("success");
          setSnackbarOpen(true);
          setShowViewSchedule(true);
          fetchAssociatedHospitalList();
          setLoading(false); // 🔹 Temporarily stop loader to show message

          setTimeout(() => {
            setLoading(true); // 🔹 Show loader again before tab switch
            onTabChange();
            setLoading(false); // 🔹 Finally stop loader after tab switch
          }, 1000); // Let user read the message for 3 seconds

          return;
        } else if (response.result.responseCode == 0) {
          setSnackbarMessage(
            "Contact and NEW Medicare Provider ID relationship already exist.",
          );
          setError("error");
        } else if (response.result.responseCode == 2) {
          setSnackbarMessage(
            "Schedule already added for selected date and time!",
          );
          setError("error");
        } else {
          setSnackbarMessage("Failed to update schedule details!");
          setError("error");
        }
      } else {
        const response = await addDoctorSchedule(payload);
        if (response.result.responseCode == 1) {
          setSnackbarMessage("Doctor schedule added successfully!");
          fetchAssociatedHospitalList();
          resetManualLocationFields();
          setError("success");
          setTimeout(() => {
            setLoading(true); // 🔹 Show loader again before tab switch
            onTabChange();
            setLoading(false); // 🔹 Finally stop loader after tab switch
          }, 1000); // Let user read the message for 3 seconds
        } else if (response.result.responseCode == 0) {
          setSnackbarMessage(
            "Contact and NEW Medicare Provider ID relationship already exist.",
          );
          setError("error");
        } else if (response.result.responseCode == 2) {
          setSnackbarMessage(
            "Schedule already added for selected date and time!",
          );
          setError("error");
        } else if (response.result.responseCode == 3) {
          setSnackbarMessage(
            "The selected date and time are already reserved. Please choose a different availability slot!",
          );
          setError("error");
        } else {
          setSnackbarMessage("Failed to add schedule details!");
          setError("error");
        }
      }

      setSnackbarOpen(true);

      setShowViewSchedule(true);
    } catch (error) {
      setSnackbarMessage("Failed to save/update schedule. Please try again.");
      setError("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const getWeekdaysInRange = (start: Date, end: Date): string[] => {
    const daysInRange = new Set<string>();
    let current = new Date(start);
    current.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);

    while (current <= end) {
      const weekday = moment(current).format("ddd"); // 'Mon', 'Tue', etc.
      daysInRange.add(weekday);
      current.setDate(current.getDate() + 1);
    }

    return Array.from(daysInRange);
  };

  const handleDateRangeChange = (range: [Date | null, Date | null]) => {
    setDateRange(range);
    const [start, end] = range;

    if (start && end) {
      const valid = getWeekdaysInRange(start, end);
      console.log("Valid weekdays:", valid);
      setValidDays(valid);
    } else {
      setValidDays([]);
    }
  };

  const [isCancel, setIsCancel] = useState(false);

  const handleConfirmCancel = async () => {
    setIsCancel(true);
    const scheduleId = selectedRowData?.scheduleId;

    try {
      if (selectedRowData && scheduleId) {
        // Directly bind form data from selectedRowData
        // (No API call needed since you already have all the data)

        // Schedule Type & Mode
        setScheduleStatus(selectedRowData.scheduleType || "");
        setAvailabilityBy(
          selectedRowData.scheduleMode === "Month" ? "Month" : "Date Range",
        );

        // Selected Months
        setselectedMonth(
          selectedRowData.selectedMonths
            ? selectedRowData.selectedMonths.split(",")
            : [],
        );

        // Selected Weekdays
        setAvailableDays(
          selectedRowData.selectedWeekdays
            ? selectedRowData.selectedWeekdays.split(",")
            : [],
        );

        // Date Range
        const startDate = selectedRowData.startDate
          ? new Date(selectedRowData.startDate)
          : null;
        const endDate = selectedRowData.endDate
          ? new Date(selectedRowData.endDate)
          : null;
        setDateRange([startDate, endDate]);

        // Time (local)
        const extractLocalTime = (iso: string | null) => {
          if (!iso) return "";
          const date = new Date(iso);
          return `${String(date.getHours()).padStart(2, "0")}:${String(
            date.getMinutes(),
          ).padStart(2, "0")}`;
        };
        setStartTime(extractLocalTime(selectedRowData.startTime));
        setEndTime(extractLocalTime(selectedRowData.endTime));

        // Match Medicare Hospital
        const matchedHospital = associatedHospitalOptions.find(
          (h) =>
            String(h.medicareId) === String(selectedRowData.medicareProviderId),
        );
        if (matchedHospital) {
          setSelectedHospital(matchedHospital);
          setsetcontactMedicareListId(matchedHospital.medicareId);
        } else {
          setSelectedHospital(null);
          setsetcontactMedicareListId(undefined);
        }

        // Non-availability Reason
        setnonAvailabilityReason(selectedRowData.nonAvailabilityReason || "");

        // Store result
        setResult(selectedRowData);
      } else {
        // No selection or missing scheduleId — reset the form
        resetForm();
      }

      setOpenConfirm(false); // Close the confirmation dialog
    } catch (error) {
      console.error("Error while cancelling schedule:", error);
      setSnackbarMessage("Failed to cancel schedule. Please try again.");
      setError("error");
      setSnackbarOpen(true);
    }
  };

  const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };

  const [availabledetailKey, setavailabledetailKey] = useState<string | null>(
    "0",
  );

  const availabledetailAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={availabledetailKey}
      onSelect={(key) => setavailabledetailKey(key as string)}
    />
  );

  const [selectlocationKey, setselectlocationKey] = useState<string | null>(
    "0",
  );

  const selectlocationAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={selectlocationKey}
      onSelect={(key) => setselectlocationKey(key as string)}
    />
  );

  const [searchResults, setSearchResults] = useState<
    HospitalClinicSearchResult[]
  >([]);

  const handleSearch = async (query: string) => {
    try {
      // Optional: setLoading(true);

      const response = await searchManualZipCode({
        SearchString: query,
        pageNo: 0,
        pageSize: 0,
        sortColumn: "",
        sortOrder: "",
      });

      const results: HospitalClinicSearchResult[] = response?.result || [];

      if (results.length > 0) {
        setSearchResults(results);

        const cities = [
          ...new Set(results.map((r) => r.physicalCity).filter(Boolean)),
        ];
        const zips = [
          ...new Set(results.map((r) => r.physicalZip).filter(Boolean)),
        ];
        const states = [
          ...new Set(results.map((r) => r.physicalState).filter(Boolean)),
        ];
        const countries = [
          ...new Set(results.map((r) => r.country).filter(Boolean)),
        ];

        setCityOptions(cities);
        setZipOptions(zips);
        setStateOptions(states);
        setCountryOptions(countries);

        // Clear only if selected value is no longer valid
        if (!cities.includes(manualCity)) setManualCity("");
        if (!zips.includes(manualZip)) setManualZip("");
        if (!states.includes(manualState)) setManualState("");
        if (!countries.includes(manualCountry)) setManualCountry("");
      }
    } catch (error) {
      console.error("Error searching clinic data:", error);
    } finally {
      // Optional: setLoading(false);
    }
  };

  // Update dropdown options from unfiltered searchResults
  useEffect(() => {
    const cities = [
      ...new Set(searchResults.map((r) => r.physicalCity).filter(Boolean)),
    ];
    const states = [
      ...new Set(searchResults.map((r) => r.physicalState).filter(Boolean)),
    ];
    const countries = [
      ...new Set(searchResults.map((r) => r.country).filter(Boolean)),
    ];
    const zips = [
      ...new Set(searchResults.map((r) => r.physicalZip).filter(Boolean)),
    ];

    setCityOptions(cities);
    setStateOptions(states);
    setCountryOptions(countries);
    setZipOptions(zips);
  }, [searchResults]);

  useEffect(() => {
    if (!manualCity && !manualZip) return;

    let filtered = [...searchResults];

    if (manualCity?.trim()) {
      filtered = filtered.filter(
        (item) =>
          item.physicalCity?.toLowerCase() === manualCity.trim().toLowerCase(),
      );
    }

    if (manualZip?.trim()) {
      filtered = filtered.filter(
        (item) =>
          item.physicalZip?.toLowerCase() === manualZip.trim().toLowerCase(),
      );
    }

    const cities = [
      ...new Set(filtered.map((r) => r.physicalCity).filter(Boolean)),
    ];
    const zips = [
      ...new Set(filtered.map((r) => r.physicalZip).filter(Boolean)),
    ];
    const states = [
      ...new Set(filtered.map((r) => r.physicalState).filter(Boolean)),
    ];
    const countries = [
      ...new Set(filtered.map((r) => r.country).filter(Boolean)),
    ];

    setCityOptions(cities);
    setZipOptions(zips);
    setStateOptions(states);
    setCountryOptions(countries);

    if (cities.length === 1 && !manualCity) setManualCity(cities[0]);
    if (zips.length === 1 && !manualZip) setManualZip(zips[0]);
    if (states.length === 1 && !manualState) setManualState(states[0]);
    if (countries.length === 1 && !manualCountry)
      setManualCountry(countries[0]);
  }, [manualCity, manualZip, searchResults]);

  const resetManualLocationFields = () => {
    setIsManualEntry(false);
    setManualLocation("");
    setManualAddress("");
    setManualCity("");
    setManualState("");
    setManualCountry("");
    setManualZip("");
    setCityOptions([]);
    setStateOptions([]);
    setCountryOptions([]);
    setZipOptions([]);
  };

  const handleEnterNewLocation = () => {
    setIsManualEntry(true);
    setIsManualLocation(false);
  };

  const [reasonForAction, setReasonForAction] = useState<string>("");
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [appointmentCount, setAppointmentCount] = useState<number>(0);
  const [appointmentList, setAppointmentList] = useState<any[]>([]);

  const getAppointmentListWhileAddingUnAvailability = async () => {
    try {
      const payload = {
        qmeDoctorContactId: stakeholderContactId,
        selectedMonths:
          selectedMonth && selectedMonth.length > 0
            ? selectedMonth.join(",")
            : null,
        startDate: dateRange[0] ? formatDateTime(dateRange[0]) : null,
        endDate: dateRange[1] ? formatDateTime(dateRange[1]) : null,
        selectedWeekDays: availableDays ? availableDays.join(",") : null,
        triggerById: loggedInUserid,
      };

      const response = await ValidateAppointmentByDateandMonth(payload);
      const appointmentCount = response.length;

      setAppointmentCount(appointmentCount);
      setAppointmentList(response);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Run only when Non-Availability is selected
    if (scheduleStatus === "Non-Availability") {
      const hasAvailableDays = availableDays && availableDays.length > 0;

      if (
        availabilityBy === "Month" &&
        selectedMonth.length > 0 &&
        hasAvailableDays
      ) {
        getAppointmentListWhileAddingUnAvailability();
      }

      if (
        availabilityBy === "Date Range" &&
        dateRange?.length === 2 &&
        hasAvailableDays
      ) {
        getAppointmentListWhileAddingUnAvailability();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scheduleStatus, availabilityBy, selectedMonth, dateRange, availableDays]);

  const [appointmentlistKey, setAppointmentlistKey] = useState<string | null>(
    null,
  );

  const appointmentListAccordion = (
    items: { title: JSX.Element; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={appointmentlistKey}
      onSelect={(key) => setAppointmentlistKey(key as string)}
    />
  );

  const handleConfirmCancelButton = async () => {
    try {
      setLoading(true);
      if (appointmentCount > 0) {
        const subjectQmeScheduleIds = appointmentList
          .map((item) => item.subjectQmeScheduleId)
          .join(",");

        const payload = {
          subjectQmeScheduleIds: subjectQmeScheduleIds, // e.g., "241,234"
          startDate: null,
          startTime: null,

          providerAddress: null,
          note: cancelReason,
        };
        const getCurrentTime = () => {
          const now = new Date();
          return `${String(now.getHours()).padStart(2, "0")}:${String(
            now.getMinutes(),
          ).padStart(2, "0")}`;
        };
        let response = await RequestForRescheduleAppointment(payload);
        if (response?.data?.subjectQmeScheduleId) {
          const today = new Date();
          const todayStr = today.toISOString().split("T")[0];

          const parsedStartTime = `${todayStr}T${startTime || getCurrentTime()}:00`;
          const parsedEndTime = `${todayStr}T${endTime || getCurrentTime()}:00`;

          const parsedStartDate = dateRange[0]
            ? new Date(dateRange[0]).toLocaleDateString("en-CA") // "YYYY-MM-DD" format
            : null;

          const parsedEndDate = dateRange[1]
            ? new Date(dateRange[1]).toLocaleDateString("en-CA")
            : null;

          let fixedLoc: {
            latitude?: number | null;
            longitude?: number | null;
          } = {};

          let splInstructionsPayload: any[] = [];
          splInstructionsPayload = instructionOption.map((opt: any) => ({
            SplInstructionID: opt.value,
            SplInstructionData: "",
          }));
          const basePayload: DoctorSchedulePayload = {
            scheduleId: selectedRowData?.scheduleId || 0,
            qmeDoctorContactId: Number(stakeholderContactId),
            scheduleType: scheduleStatus,
            scheduleMode: availabilityBy,
            selectedMonths: selectedMonth.join(","),
            startDate: parsedStartDate,
            endDate: parsedEndDate,
            selectedWeekDays: availableDays.join(","),
            startTime: parsedStartTime,
            endTime: parsedEndTime,
            medicareProviderId: isManualEntry
              ? null
              : scheduleStatus === "Non-Availability"
                ? null
                : !isOtherHospitalVisible &&
                    setcontactMedicareListId &&
                    Number(setcontactMedicareListId) !== 0
                  ? Number(setcontactMedicareListId)
                  : null,

            newMedicareProviderId: isManualEntry
              ? null
              : scheduleStatus === "Non-Availability"
                ? null
                : isOtherHospitalVisible &&
                    setcontactMedicareListId &&
                    Number(setcontactMedicareListId) !== 0
                  ? Number(setcontactMedicareListId)
                  : null,

            newEmailAddress: "",
            newPhoneNumber: "",
            newFaxNumber: "",
            nonAvailabilityReason: String(nonAvailabilityReason) || "",
            newMedicareName: manualLocation ? manualLocation : "",
            newAddressLine1: manualAddress ? manualAddress : "",
            newCity: manualCity ? manualCity : "",
            newState: manualState ? manualState : "",
            newZip: manualZip ? manualZip : "",
          };

          const payload = {
            ...basePayload,
            ...(manualLocation &&
              isValidCoordinate(fixedLoc?.latitude) &&
              isValidCoordinate(fixedLoc?.longitude) && {
                latitude: String(fixedLoc.latitude),
                longitude: String(fixedLoc.longitude),
              }),
            ...(manualLocation && {
              splInstructions: splInstructionsPayload,
            }),
          };

          if (selectedRowData?.scheduleId) {
            const response = await updateDoctorSchedule(payload);
            if (response.result.id > 0) {
              setTimeout(() => {
                setLoading(true); // 🔹 Show loader again before tab switch
                onTabChange();
                setLoading(false); // 🔹 Finally stop loader after tab switch
              }, 1000); // Let user read the message for 3 seconds

              return;
            }
          } else {
            const response = await addDoctorSchedule(payload);
            if (response.result.responseCode == 1) {
              setTimeout(() => {
                setLoading(true); // 🔹 Show loader again before tab switch
                onTabChange();
                setLoading(false); // 🔹 Finally stop loader after tab switch
              }, 1000); // Let user read the message for 3 seconds
            }
          }

          setSnackbarOpen(true);

          setShowViewSchedule(true);

          setSnackbarMessage(
            "Appointment has been rescheduled successfully and unavailable added.",
          );
          setError("success");
          setSnackbarOpen(true);
          setShowCancelModal(false);
          setAppointmentCount(0);
          setCancelReason("");
        }
      }
    } catch (error: any) {
      setSnackbarMessage(error.message || "An error occurred");
      setError("error");
      setSnackbarOpen(true);
    }
  };

  const handleAddressSuggestionSelect = async (suggestion: any) => {
    setIsManualLocation(false);
    setManualAddress(suggestion.providerAddress || "");
    setManualLocation(suggestion.providerName || "");
    const suggestedZip = suggestion.physicalZip || "";
    const newStateCode = normalizeState(suggestion.physicalState);
    const newCountryCode = normalizeCountry(suggestion.country);
    if (suggestion.physicalCity) setManualCity(suggestion.physicalCity);
    if (suggestion.physicalState) setManualState(newStateCode);
    if (suggestion.country) setManualCountry(newCountryCode);
    if (suggestion.physicalCity) setCityOptions([suggestion.physicalCity]);
    if (newStateCode) setStateOptions([newStateCode]);
    if (newCountryCode) setCountryOptions([newCountryCode]);

    if (suggestedZip) {
      setManualZip(suggestedZip);
      setZipOptions([suggestedZip]);

      try {
        const response = await searchManualZipCode({
          SearchString: suggestedZip,
          pageNo: 0,
          pageSize: 10,
          sortColumn: "",
          sortOrder: "",
        });

        const results = response?.result || [];

        if (results.length > 0) {
          const typedResults = results as HospitalClinicSearchResult[];
          const cities = [
            ...new Set(typedResults.map((r) => r.physicalCity).filter(Boolean)),
          ] as string[];
          const zips = [
            ...new Set(typedResults.map((r) => r.physicalZip).filter(Boolean)),
          ] as string[];
          const states = [
            ...new Set(
              typedResults.map((r) => r.physicalState).filter(Boolean),
            ),
          ] as string[];
          const countries = [
            ...new Set(typedResults.map((r) => r.country).filter(Boolean)),
          ] as string[];

          setCityOptions(cities);
          setZipOptions(zips);
          setStateOptions(states);
          setCountryOptions(countries);
        }
      } catch (error) {
        console.error("Zip lookup failed, using suggestion values:", error);
      }
    }
  };

  const handleManualLocationAdd = () => {
    setIsManualLocation(true);
    setManualLocation("");
    setManualAddress("");
    setManualCity("");
    setManualState("");
    setManualZip("");
    setManualCountry("");
  };

  useEffect(() => {
    if (!dropdownOpen || !dropdownRef.current) return;

    const rect = dropdownRef.current.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    const spaceBelow = viewportHeight - rect.bottom;
    const spaceAbove = rect.top;

    const DROPDOWN_HEIGHT = 260;

    if (spaceBelow < DROPDOWN_HEIGHT && spaceAbove > spaceBelow) {
      setOpenUpward(true);
    } else {
      setOpenUpward(false);
    }
  }, [dropdownOpen]);

  const [openUpward, setOpenUpward] = useState(false);

  return (
    <>
      {availabledetailAccordion([
        {
          title: "Availability Details",
          content: (
            <>
              <div className="add-schedule">
                <Loader isLoading={loading} />
                <Snackbar
                  message={snackbarMessage}
                  open={snackbarOpen}
                  onClose={() => setSnackbarOpen(false)}
                  severity={error}
                />

                <Modal show={openConfirm} onHide={handleCloseConfirm}>
                  <Modal.Body className="fw-bold text-left modelheading ">
                    <div>Are you sure you want to cancel?</div>
                  </Modal.Body>
                  <Modal.Footer className="border-0 d-flex justify-content-end">
                    <Button
                      variant="outline-info"
                      className="d-flex align-items-center"
                      onClick={handleCloseConfirm}
                    >
                      <span className="material-icons mr-2">close</span> Cancel
                    </Button>
                    <Button
                      variant="primary"
                      className="ms-3 d-flex align-items-center"
                      onClick={handleConfirmCancel}
                    >
                      <span className="material-icons mx-1">check</span> Confirm
                    </Button>
                  </Modal.Footer>
                </Modal>

                <div className="mt-1 d-flex align-items-center">
                  <div className="me-4" style={{ width: "150px" }}>
                    <label>Schedule Status</label>
                  </div>
                  <div>
                    {" "}
                    <RadioGroup
                      row
                      value={scheduleStatus}
                      onChange={(e) => setScheduleStatus(e.target.value)}
                    >
                      <FormControlLabel
                        value="Availability"
                        control={<Radio color="primary" />}
                        style={{ width: "130px", marginRight: "0px" }}
                        label="Availability"
                        disabled={selectedRowData}
                      />
                      <FormControlLabel
                        value="Non-Availability"
                        control={<Radio color="primary" />}
                        style={{ width: "160px", marginRight: "0px" }}
                        label="Unavailability"
                        disabled={selectedRowData}
                      />
                    </RadioGroup>
                  </div>
                </div>

                <div className="mt-1 d-flex align-items-center">
                  <div className="me-4" style={{ width: "150px" }}>
                    Availability By
                  </div>
                  <div>
                    <RadioGroup
                      row
                      value={availabilityBy}
                      onChange={handleAvailabilityChange}
                    >
                      <FormControlLabel
                        value="Month"
                        control={<Radio color="primary" />}
                        label="By Month"
                        style={{ width: "130px", marginRight: "0px" }}
                        disabled={selectedRowData}
                      />
                      <FormControlLabel
                        value="Date Range"
                        control={<Radio color="primary" />}
                        label="By Date Range"
                        style={{ width: "160px", marginRight: "0px" }}
                        disabled={selectedRowData}
                      />
                    </RadioGroup>
                  </div>
                </div>

                <Row className="mt-3">
                  {availabilityBy === "Month" && (
                    <Col sm={4} className="selection_dropdown ">
                      <SearchableMultiSelectDropdown
                        label="Select Month"
                        options={monthOptions}
                        name="Month"
                        values={selectedMonth}
                        required
                        disabled={selectedRowData?.isReadOnly == 1}
                        onChange={(event, name, values) =>
                          setselectedMonth(values as string[])
                        }
                      />
                    </Col>
                  )}

                  {availabilityBy === "Date Range" && (
                    <Col sm={4} className="customDrodownControlDAtepicker">
                      <DateRangePicker
                        label="Select Start /  End Date"
                        startDate={dateRange[0] ?? undefined}
                        endDate={dateRange[1] ?? undefined}
                        onChange={handleDateRangeChange}
                        disabled={selectedRowData?.isReadOnly == 1}
                        minDate={new Date()}
                        required
                      />
                    </Col>
                  )}

                  <Col sm={8} className="d-flex align-items-center">
                    <div className="d-flex align-items-center justify-content-start">
                      <div className="me-3 fw-bold">
                        Weekday <span className="text-danger">*</span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "10px",
                        }}
                      >
                        {days.map((day) => {
                          const dayIndex = dayToIndexMap[day];
                          const isDisabled =
                            (validDays.length > 0 &&
                              !validDays.includes(day)) ||
                            unavailableWeekdays.includes(day);

                          return (
                            <FormControlLabel
                              key={day}
                              control={
                                <Checkbox
                                  checked={availableDays.includes(day)}
                                  onChange={() => handleDayChange(day)}
                                  disabled={
                                    isDisabled ||
                                    selectedRowData?.isReadOnly == 1
                                  }
                                />
                              }
                              label={day}
                            />
                          );
                        })}
                      </div>
                    </div>
                  </Col>

                  {scheduleStatus === "Availability" && (
                    <>
                      <Row className="mt-4">
                        <Col md={12}>Time Slot</Col>
                      </Row>
                      <Row className="mt-3">
                        <Col sm={2}>
                          <TimePicker
                            selectedTime={startTime}
                            onChange={handleStartTimeChange}
                            disabled={selectedRowData?.isReadOnly == 1}
                            label="Start Time"
                            required
                          />
                        </Col>
                        <Col sm={2}>
                          <EndTimePicker
                            selectedTime={endTime}
                            onChange={setEndTime}
                            label="End Time"
                            disabled={
                              !startTime || selectedRowData?.isReadOnly == 1
                            }
                            startTime={startTime}
                            isAppointment={true}
                            required
                          />
                        </Col>
                        <Col sm={2}>
                          <TextInput
                            label="Duration"
                            name="duration"
                            value={duration}
                            onChange={(e) => {
                              setDuration(e.target.value);
                            }}
                            disabled
                          />
                        </Col>
                      </Row>
                    </>
                  )}
                  {scheduleStatus === "Non-Availability" && (
                    <>
                      <Col md={12} className="mt-3 mb-3">
                        <TextInput
                          label="Unavailability Notes"
                          name="unavailabilityNotes"
                          maxLength={500}
                          value={nonAvailabilityReason}
                          onChange={(e) =>
                            setnonAvailabilityReason(e.target.value)
                          }
                          disabled={selectedRowData?.isReadOnly == 1}
                        />
                      </Col>
                    </>
                  )}
                </Row>
                {scheduleStatus === "Availability" ? (
                  <Row className="mt-3">
                    <Col classname="mt-3">
                      {selectlocationAccordion([
                        {
                          title: " Select Availability Location",
                          content: (
                            <>
                              {scheduleStatus === "Availability" && (
                                <>
                                  <Row>
                                    <Col md={9}>
                                      <div
                                        className="form-floating"
                                        ref={dropdownRef}
                                        onClick={() =>
                                          !isOtherHospitalVisible &&
                                          setDropdownOpen(!dropdownOpen)
                                        }
                                        style={{ position: "relative" }}
                                      >
                                        <input
                                          type="text"
                                          name="QME Doctor Associated Location"
                                          className="form-control zipcodeDetailsOverlay"
                                          placeholder="QME Doctor Associated Location"
                                          maxLength={50}
                                          disabled={
                                            selectedRowData?.isReadOnly == 1 ||
                                            isOtherHospitalVisible
                                          }
                                          value={
                                            selectedHospital
                                              ? selectedHospital.providerName
                                              : ""
                                          }
                                          readOnly
                                          required
                                        />
                                        <label>
                                          QME Doctor Associated Location
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>{" "}
                                        </label>

                                        {dropdownOpen &&
                                          associatedHospitalOptions.length >
                                            0 && (
                                            <div
                                              style={{
                                                position: "absolute",
                                                left: 0,
                                                right: 0,
                                                zIndex: 1050,
                                                background: "#fff",
                                                border: "1px solid #ccc",
                                                top: openUpward
                                                  ? "auto"
                                                  : "100%",
                                                bottom: openUpward
                                                  ? "100%"
                                                  : "auto",
                                              }}
                                              onClick={(e) =>
                                                e.stopPropagation()
                                              }
                                            >
                                              <ul
                                                className="list-group"
                                                style={{
                                                  maxHeight: "200px",
                                                  overflowY: "auto",
                                                }}
                                              >
                                                <li
                                                  className="list-group-item d-flex justify-content-between align-items-center"
                                                  style={{
                                                    fontWeight: "bold",
                                                    backgroundColor: "#f8f9fa",
                                                  }}
                                                >
                                                  <div style={{ width: "10%" }}>
                                                    Select
                                                  </div>
                                                  <div style={{ width: "30%" }}>
                                                    Location
                                                  </div>
                                                  <div style={{ width: "20%" }}>
                                                    City
                                                  </div>
                                                  <div style={{ width: "20%" }}>
                                                    State
                                                  </div>
                                                  <div style={{ width: "10%" }}>
                                                    Country
                                                  </div>
                                                  <div style={{ width: "10%" }}>
                                                    Zipcode
                                                  </div>
                                                </li>

                                                {associatedHospitalOptions.map(
                                                  (option) => (
                                                    <li
                                                      key={option.physicalZip}
                                                      className={`list-group-item d-flex justify-content-between align-items-center ${
                                                        selectedHospital?.providerName ===
                                                        option.providerName
                                                          ? "selected-row"
                                                          : ""
                                                      }`}
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() =>
                                                        handleSelectDropdown(
                                                          option,
                                                        )
                                                      }
                                                    >
                                                      <div
                                                        style={{
                                                          width: "10%",
                                                        }}
                                                      >
                                                        <input
                                                          type="radio"
                                                          name="location"
                                                          checked={
                                                            selectedHospital?.providerName ===
                                                            option.providerName
                                                          }
                                                          onChange={() =>
                                                            handleSelectDropdown(
                                                              option,
                                                            )
                                                          }
                                                        />
                                                      </div>
                                                      <div
                                                        style={{
                                                          width: "30%",
                                                        }}
                                                      >
                                                        {option.providerName}
                                                      </div>
                                                      <div
                                                        style={{
                                                          width: "20%",
                                                        }}
                                                      >
                                                        {option.physicalCity}
                                                      </div>
                                                      <div
                                                        style={{
                                                          width: "20%",
                                                        }}
                                                      >
                                                        {option.physicalState}
                                                      </div>
                                                      <div
                                                        style={{
                                                          width: "10%",
                                                        }}
                                                      >
                                                        {option.countryName}
                                                      </div>
                                                      <div
                                                        style={{
                                                          width: "10%",
                                                        }}
                                                      >
                                                        {option.physicalZip}
                                                      </div>
                                                    </li>
                                                  ),
                                                )}
                                              </ul>
                                            </div>
                                          )}
                                      </div>
                                    </Col>
                                    <Col
                                      md={3}
                                      className=" d-flex align-items-center"
                                    >
                                      <Form.Check
                                        type="switch"
                                        id="toggle-hospital"
                                        label={
                                          isOtherHospitalVisible
                                            ? "Add Other Location"
                                            : "Add Other Location"
                                        }
                                        checked={isOtherHospitalVisible}
                                        onChange={handleToggleOtherHospital}
                                        disabled={
                                          selectedRowData?.isReadOnly == 1
                                        }
                                      />
                                    </Col>
                                  </Row>

                                  <>
                                    {!isOtherHospitalVisible &&
                                      selectedHospital && (
                                        <>
                                          <Row className="mt-3 align-items-center">
                                            <Col md={12}>
                                              <h5 className="sectionTitle">
                                                Details
                                              </h5>
                                            </Col>

                                            {!isOtherHospitalVisible &&
                                              selectedHospital && (
                                                <Col md={12}>
                                                  <HospitalCardDetails
                                                    ProviderName={
                                                      selectedHospital.providerName
                                                    }
                                                    Address={
                                                      selectedHospital.providerAddress
                                                    }
                                                    ContactName={
                                                      selectedHospital.locationContactName
                                                    }
                                                    EmailAddress={
                                                      selectedHospital.emailAddress
                                                    }
                                                    PhoneNumber={
                                                      selectedHospital.phoneNumber
                                                    }
                                                  />
                                                </Col>
                                              )}
                                          </Row>
                                        </>
                                      )}
                                  </>

                                  <>
                                    {!isManualEntry &&
                                    isOtherHospitalVisible ? (
                                      <Row className="mt-3">
                                        <Col md={12}>
                                          <SearchHospitalAutosuggest
                                            value={searchQuery}
                                            onChange={setSearchQuery}
                                            onSuggestionSelect={handleSuggestionSelect}
                                            onEnterNewLocation={handleEnterNewLocation}
                                            showEnterNewLocation={isAddManualLocation}
                                            label="Location"
                                            maxLength={50}
                                            disabled={selectedRowData?.isReadOnly == 1}
                                            searchApi={(query) => getdHospitalList(query).then((data: any) => ({ result: Array.isArray(data) ? data : [] }))}
                                          />
                                        </Col>
                                      </Row>
                                    ) : null}
                                  </>

                                  <>
                                    {!isManualEntry &&
                                    isOtherHospitalVisible ? (
                                      <Row className="mt-3 mb-3">
                                        <Col md={12}>
                                          <TextInput
                                            label="Address"
                                            name="Address"
                                            value={address}
                                            maxLength={100}
                                            required
                                            onChange={(e) =>
                                              setAddress(e.target.value)
                                            }
                                            disabled
                                          />
                                        </Col>
                                        <Col md={3} className="mt-3">
                                          <TextInput
                                            label="City"
                                            name="City"
                                            value={city}
                                            maxLength={100}
                                            required
                                            onChange={(e) =>
                                              setCity(e.target.value)
                                            }
                                            disabled={!suggestionSelected || suggestionFilled.city}
                                          />
                                        </Col>
                                        <Col md={3} className="mt-3">
                                          <TextInput
                                            name="State"
                                            label="State"
                                            required
                                            value={state}
                                            maxLength={!suggestionSelected || suggestionFilled.state ? 100 : 3}
                                            onChange={(e) =>
                                              setState(e.target.value)
                                            }
                                            disabled={!suggestionSelected || suggestionFilled.state}
                                          />
                                        </Col>
                                        <Col md={3} className="mt-3">
                                          <TextInput
                                            name="Country"
                                            label="Country"
                                            value={country}
                                            required
                                            maxLength={4}
                                            onChange={(e) =>
                                              setCountry(e.target.value)
                                            }
                                            disabled={!suggestionSelected || suggestionFilled.country}
                                          />
                                        </Col>
                                        <Col md={3} className="mt-3">
                                          <TextInput
                                            name="ZipCode"
                                            label="Zip Code"
                                            value={zipCode}
                                            required
                                            maxLength={!suggestionSelected || suggestionFilled.zipCode ? 100 : 10}
                                            onChange={(e) =>
                                              setZipCode(e.target.value.replace(/\D/g, ""))
                                            }
                                            disabled={!suggestionSelected || suggestionFilled.zipCode}
                                          />
                                        </Col>
                                      </Row>
                                    ) : null}

                                    {isManualEntry && (
                                      <>
                                        <Row className="row mb-3 mt-3">
                                          <Col md={12}>
                                            {!isManualLocation ? (
                                              <SearchAutosuggest
                                                value={manualLocation}
                                                onChange={setManualLocation}
                                                onSuggestionSelect={
                                                  handleAddressSuggestionSelect
                                                }
                                                onManualLocationAdd={
                                                  handleManualLocationAdd
                                                }
                                                enableManualLocation={true}
                                                label="Location"
                                                required
                                                apiKey={
                                                  process.env
                                                    .REACT_APP_GOOGLE_PLACES_AUTOCOMPLETE_API_KEY
                                                }
                                                countryRestriction="us"
                                                sortingLocation="Location"
                                                maxLength={100}
                                              />
                                            ) : (
                                              <TextInput
                                                label="Location"
                                                name="Location"
                                                value={manualLocation}
                                                onChange={(e) =>
                                                  setManualLocation(
                                                    e.target.value,
                                                  )
                                                }
                                                maxLength={100}
                                                required
                                              />
                                            )}
                                          </Col>
                                        </Row>
                                        <Row className="row mb-3">
                                          <Col md={12}>
                                              <TextInput
                                                label="Address Line 1"
                                                name="Address Line 1"
                                                value={manualAddress}
                                                onChange={(e) =>
                                                  setManualAddress(
                                                    e.target.value,
                                                  )
                                                }
                                                maxLength={100}
                                                required
                                              />
                                          </Col>
                                        </Row>
                                        <Row className="mb-3 mt-3 loc-details">
                                          <Col md={3}>
                                            <SearchableAddressDropdown
                                              label="City"
                                              value={manualCity}
                                              options={cityOptions}
                                              onSearch={handleSearch}
                                              onSelect={(val) =>
                                                setManualCity(val)
                                              }
                                              disabled={!isManualLocation}
                                            />
                                          </Col>
                                          <Col md={3}>
                                            <SearchableAddressDropdown
                                              label="State"
                                              value={manualState}
                                              options={stateOptions}
                                              onSearch={handleSearch}
                                              onSelect={(val) =>
                                                setManualState(val)
                                              }
                                              required={true}
                                              disabled={
                                                (!manualCity && !manualZip) ||
                                                stateOptions.length === 1 ||
                                                !isManualLocation
                                              }
                                            />
                                          </Col>
                                          <Col md={3}>
                                            <SearchableAddressDropdown
                                              label="Country"
                                              value={manualCountry}
                                              options={countryOptions}
                                              onSearch={handleSearch}
                                              onSelect={(val) =>
                                                setManualCountry(val)
                                              }
                                              required={true}
                                              disabled
                                            />
                                          </Col>
                                          <Col md={3}>
                                            <SearchableAddressDropdown
                                              label="Zip"
                                              value={manualZip}
                                              options={zipOptions}
                                              onSearch={handleSearch}
                                              onSelect={(val) =>
                                                setManualZip(val)
                                              }
                                              disabled={!isManualLocation}
                                            />
                                          </Col>
                                        </Row>
                                      </>
                                    )}
                                  </>
                                </>
                              )}
                            </>
                          ),
                        },
                      ])}
                    </Col>
                  </Row>
                ) : (
                  ""
                )}
                <Row>
                  <Col className="d-flex justify-content-end ">
                    <Button
                      variant="outline-info"
                      className="d-flex align-items-center"
                      onClick={handleCancel}
                      disabled={selectedRowData?.isReadOnly == 1}
                    >
                      <span className="material-icons mr-2">close</span> Cancel
                    </Button>

                    <Button
                      type="submit"
                      variant="primary"
                      className="d-flex align-items-center ml-2"
                      onClick={handleSave}
                      disabled={selectedRowData?.isReadOnly == 1}
                    >
                      <span className="material-icons mx-1">save</span> Save
                    </Button>
                  </Col>
                </Row>
              </div>
            </>
          ),
        },
      ])}
      {/* )} */}
      <Modal
        show={showCancelModal}
        onHide={() => {
          setShowCancelModal(false);
          setCancelReason("");
          setAppointmentlistKey(null);
        }}
        centered
        size="xl"
      >
        <Modal.Body className="text-center">
          {/* Header Text */}
          <h5 className="fw-bold mb-2">
            Are you sure you want to add unavailibility?
          </h5>

          {/* Red Warning Text */}
          <p className="text-danger mb-4" style={{ fontSize: "14px" }}>
            {appointmentCount} Appointment(s) scheduled during this time span
            will be requested for reschedule
          </p>

          {/* Reason Textarea (using MultilineTextBox) */}
          <Row className="mt-3 px-3">
            <Col sm={12}>
              <MultilineTextBox
                label="Reason"
                name="reason"
                value={cancelReason ?? ""}
                onChange={(e) => {
                  let value = e.target.value;
                  if (value.startsWith(" ")) return;
                  value = value?.trimStart();
                  value = value.replace(/ {2,}/g, " ");
                  setCancelReason(value);
                }}
                maxLength={100}
              />
            </Col>
          </Row>

          {/* Accordion shown only if appointmentCount > 0 */}
          <Row className="mt-3 px-3">
            <Col sm={12}>
              {appointmentCount > 0 &&
                appointmentListAccordion([
                  {
                    title: (
                      <div className="d-flex align-items-center">
                        <span>Appointment List</span>
                        {!appointmentlistKey && (
                          <Badge
                            pill
                            bg="primary"
                            className="ms-2 primary-badge"
                          >
                            {appointmentCount}
                          </Badge>
                        )}
                      </div>
                    ),
                    content: (
                      <>
                        <Row className="mt-3 px-3">
                          <DataTable
                            headers={APPOINTMENT_LIST_ON_VIEW_SCHEDULE}
                            rows={appointmentList}
                          />
                        </Row>
                      </>
                    ),
                  },
                ])}
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer className="border-top d-flex justify-content-end">
          <Button
            variant="outline-info"
            onClick={() => {
              setShowCancelModal(false);
              setCancelReason("");
              setAppointmentlistKey(null);
            }}
            className="d-flex align-items-center"
          >
            <span className="material-icons me-1">close</span> Cancel
          </Button>

          <Button
            variant="primary"
            onClick={handleConfirmCancelButton}
            className="d-flex align-items-center ms-2"
          >
            <span className="material-icons me-1">check</span> Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AvailabilityForm;
